
import { QueryClientProvider } from 'react-query';
import Rotas from './routes/routes';
import queryClient from './services/query';
import { ToastContainer } from 'react-toastify';
import { ThemeProvider } from "@mui/material";
import { theme } from "./theme";

const title = document.getElementById('title');

if (title) title.innerText = `${process.env.REACT_APP_PROJECT_NAME}`

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
      <ToastContainer />
        <Rotas />
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
